import shfaqPorosit from "./Porosit/shfaqPorosit.json";
import shfaqTeDhenatEPorosise from "./Porosit/shfaqTeDhenatEPorosise.json";
import shfaq15ProduktetMeTeFundit from "./Produktet/shfaq15ProduktetMeTeFundit.json";
import shfaqProduktet from "./Produktet/shfaqProduktet.json";
import shfaqRegjistrimet from "./Regjistrimet/shfaqRegjistrimet.json";
import shfaqTeDhenatKalkulimit from "./Regjistrimet/shfaqTeDhenatKalkulimit.json";
import shfaq15PerdoruesitMeSeShumtiBlerje from "./Statistikat/shfaq15PerdoruesitMeSeShumtiBlerje.json";
import shfaq15ProduktetMeTeShitura from "./Statistikat/shfaq15ProduktetMeTeShitura.json";
import shfaqTotaleTeNdryshme from "./Statistikat/shfaqTotaleTeNdryshme.json";
import shfaqTotaletJavore from "./Statistikat/shfaqTotaletJavore.json";
import shfaqKategorit from "./shfaqKategorit.json";
import shfaqKodet from "./shfaqKodet.json";
import shfaqKompanit from "./shfaqKompanit.json";
import shfaqMesazhet from "./shfaqMesazhet.json";
import shfaqPerdoruesit from "./shfaqPerdoruesit.json";
import shfaqRolet from "./shfaqRolet.json";
import shfaqTeDhenatBiznesit from "./shfaqTeDhenatBiznesit.json";
import shfaqZbritjet from "./shfaqZbritjet.json";
import { shiftRecordDates, shiftNestedRecordDates } from "./dateShift";

// These JSON fixtures contain hardcoded calendar dates that go stale over
// time (the "mock backend" has no way to compute new Date() itself). Shift
// each dataset's dates so its most recent date lands on today, preserving
// the relative spacing between all dates in that same file.
const shfaqTotaletJavoreFresh = shiftNestedRecordDates(
  shfaqTotaletJavore,
  "totaletDitore",
  ["data"]
);
const shfaqRegjistrimetFresh = shiftRecordDates(shfaqRegjistrimet, [
  "dataRegjistrimit",
]);
const shfaqMesazhetFresh = shiftRecordDates(shfaqMesazhet, ["dataDergeses"]);
const shfaqZbritjetFresh = shiftRecordDates(shfaqZbritjet, [
  "dataZbritjes",
  "dataSkadimit",
]);
const shfaqKodetFresh = shiftRecordDates(shfaqKodet, ["dataKrijimit"]);

const data = {
  shfaqPorosit,
  shfaqTeDhenatEPorosise,
  shfaq15ProduktetMeTeFundit,
  shfaqProduktet,
  shfaqRegjistrimet: shfaqRegjistrimetFresh,
  shfaqTeDhenatKalkulimit,
  shfaq15PerdoruesitMeSeShumtiBlerje,
  shfaq15ProduktetMeTeShitura,
  shfaqTotaleTeNdryshme,
  shfaqTotaletJavore: shfaqTotaletJavoreFresh,
  shfaqKategorit,
  shfaqKodet: shfaqKodetFresh,
  shfaqKompanit,
  shfaqMesazhet: shfaqMesazhetFresh,
  shfaqPerdoruesit,
  shfaqRolet,
  shfaqTeDhenatBiznesit,
  shfaqZbritjet: shfaqZbritjetFresh,
};

export default data;
